<template>
  <v-container class="pa-6">
    <div style="margin-bottom: 24px">
      <div class="component-title">{{ exam.name }}</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="items"
        ><template v-slot:divider>
          <v-icon class="pa-0">mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>
    <ExamInfo :exam="exam" @refresh="getExamData" />

    <SubjectTable :subjects="subjects" @refresh="getExamData" />

    <SubjectGroupTable :subjectGroups="subjectGroups" :subjects="subjects" @refresh="getExamData" />
    <RoomTable :rooms="rooms" :subjects="subjects" @refresh="getExamData" />
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import ExamInfo from '@/modules/exam/ExamInfo.vue'
import SubjectTable from '@/modules/exam/SubjectTable.vue'
import RoomTable from '@/modules/exam/RoomTable.vue'
import SubjectGroupTable from '@/modules/exam/SubjectGroupTable.vue'

export default {
  data() {
    return {
      exam: {},
      rooms: [],
      subjects: [],
      subjectGroups: [],
      filterQuery: {},
      items: [
        {
          text: 'Danh sách kỳ kiểm tra',
          disabled: false,
          href: '/exams'
        },
        {
          text: 'Thông tin kỳ kiểm tra',
          disabled: false
        }
      ]
    }
  },
  mounted() {
    this.getExamData()
  },
  methods: {
    ...mapActions('exam', ['fetchExam']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('subjectExamGroup', ['fetchSubjectGroups']),
    async getExamData() {
      this.$loading.active = true
      const id = this.$route.params.id
      const exam = await this.fetchExam(id)
      const rooms = await this.fetchRooms({ exam: id })
      const subjects = await this.fetchSubjects({ exam: id })
      const subjectGroups = await this.fetchSubjectGroups({ exam: id, _sort: 'index:asc' })
      this.exam = exam
      this.rooms = rooms
      this.subjects = subjects
      this.subjectGroups = subjectGroups
      this.$loading.active = false
    },
    refresh() {
      this.getProfileData()
    },
    onFilterChanged(query) {
      this.filterQuery = query
    }
  },
  components: { ExamInfo, SubjectTable, RoomTable, SubjectGroupTable }
}
</script>

<style>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
</style>
